<template>
  <div class="modal-column">
    <div class="modal-column-body mb-32px">
      <div class="my-32px text-18px">
        请在服务商处购买激活码，如已购买，请输入激活码：
      </div>
      <div class="h-input-group">
        <span class="h-input-addon">激活码</span>
        <Input v-model="code" placeholder="请输入激活码"/>
      </div>
    </div>
    <div class="modal-column-between">
      <vxe-button :loading="loading" @click="$emit('close')">取消</vxe-button>
      <vxe-button :loading="loading" :disabled="!code" status="primary" @click="doConfirm">确认激活</vxe-button>
    </div>
  </div>
</template>

<script>/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2010-2022杭州吉簿云数字科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2022年12月05日</li>
 * <li>@author     : ____′↘林永雄</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import common from "@/api/common";
import {message} from "heyui.ext";

export default {
  name: "Renewal",
  props: {
    astId: String
  },
  data() {
    return {
      code: null,
      loading: false,
    }
  },
  methods: {
    doConfirm() {
      if (this.code) {
        this.loading = true;
        const astId = this.astId ? parseInt(this.astId) : null;
        common.renewalValid(astId, this.code).then(({success, data}) => {
          if (success) {
            if (data.type === 'astNum') {
              message(`激活成功！`);
            } else if (data.type === 'compound') {
              message(`激活成功！`);
            } else {
              message(`激活成功！`);
            }
            this.$store.dispatch('init');
            this.$emit('success');
          }
        }).finally(() => this.loading = false)
      }
    }
  },
  mounted() {
    console.log('astId:', this.astId);
  },
}
</script>

<style scoped>

</style>
